<template>
	<v-container fluid>
		<div class="login-image mt-3">
			<img src="../assets/logo.png" class="login-image-content">
		</div>
		<div class="mt-3" v-bind:class="classRow">
			<div v-bind:class="classInputGroup">
				<div v-bind:class="classInputLabel">
					ユーザID
				</div>
				<v-text-field
					v-model="id"
					maxlength="20"
					:rules="[rules.required, rules.validate, rules.length]"
					counter
					v-on:keypress.enter="focusPasswd"
					tabindex="1"
					ref="signup_id"
				></v-text-field>
			</div>
		</div>
		<div class="mt-3" v-bind:class="classRow">
			<div v-bind:class="classInputGroup">
				<div v-bind:class="classInputLabel">
					パスワード
				</div>
				<v-text-field 
					v-model="passwd"
					:append-icon="show_passwd ? 'visibility' : 'visibility_off'"
					:type="show_passwd ? 'text' : 'password'"
					@click:append="show_passwd = !show_passwd"
					maxlength="20"
					:rules="[rules.required, rules.validate, rules.length]"
					counter
					v-on:keypress.enter="focusConfirmPasswd"
					tabindex="2"
					ref="signup_passwd"
				></v-text-field>
			</div>
		</div>
		<div class="mt-3" v-bind:class="classRow">
			<div v-bind:class="classInputGroup">
				<div v-bind:class="classInputLabel">
					パスワード<br v-if="!viewportExtraSmall">(確認)
				</div>
				<v-text-field 
					v-model="confirm_passwd"
					:append-icon="show_passwd ? 'visibility' : 'visibility_off'"
					:type="show_passwd ? 'text' : 'password'"
					@click:append="show_passwd = !show_passwd"
					maxlength="20"
					:rules="[rules.required, rules.validate, rules.length]"
					counter
					v-on:keypress.enter="focusName"
					tabindex="3"
					ref="signup_confirm"
				></v-text-field>
			</div>
		</div>
		<div class="mt-3" v-bind:class="classRow">
			<div v-bind:class="classInputGroup">
				<div v-bind:class="classInputLabel">
					名前
				</div>
				<v-text-field 
					v-model="name"
					maxlength="40"
					:rules="[rules.required, rules.length_name]"
					counter
					v-on:keypress.enter="focusTel"
					tabindex="4"
					ref="signup_name"
				></v-text-field>
			</div>
		</div>
		<div class="mt-3" v-bind:class="classRow">
			<div v-bind:class="classInputGroup">
				<div v-bind:class="classInputLabel">
					連絡先
				</div>
				<v-text-field 
					v-model="tel"
					maxlength="20"
					:rules="[rules.validate, rules.length_tel]"
					counter
					v-on:keypress.enter="onClickSignUp"
					tabindex="5"
					ref="signup_tel"
				></v-text-field>
			</div>
		</div>
		<div class="login-error mt-3">{{ error }}</div>
		<div class="login-btn mt-3">
			<v-btn 
				flat
				large
				color="white"
				class="primary login-btn-size"
				v-on:click="onClickSignUp"
				tabindex="6"
			>
				登録
			</v-btn>
		</div>
		<div class="link-center mt-3">
			<router-link class="text-decoration-none" :to="toLogin" tabindex="7">
				ログインページへ移動
			</router-link>
		</div>
	</v-container>
</template>
<script>
import TokenManager from '../classes/TokenManager';
import Notification from '../classes/Notification';
import {PERMISSION} from '../data/Const';
import Util from '../classes/Util';

import axios from 'axios';

const validateLength = function(value) {
	if(value.length >= 6 && 20 >= value.length)
		return true;
	return false;
};

const validateLengthName = function(value) {
	if(value.length <= 40)
		return true;
	return false;
};

const validateLengthTel = function(value) {
	if(value.length <= 20)
		return true;
	return false;
};

export default {
	name: 'SignUp',
	data () {
		return {
			show_passwd: false,
			rules: {
				required: v => !!v || '入力してください',
				validate: v => (!v) ? true : Util.isValidCharPassword(v) || '無効な文字が含まれています',
				length: v => validateLength(v) || '6文字以上20文字以下で入力してください',
				length_name: v => validateLengthName(v) || '40文字以内で入力してください',
				length_tel: v => validateLengthTel(v) || '20文字以内で入力してください',
			},
			id: '',
			passwd: '',
			confirm_passwd: '',
			name: '',
			tel: '',
			error: '',
		}
	},
	methods: {
		onClickSignUp: function() {
			Object.keys(this.form).forEach(f => {
				 this.$refs[f].validate(true);
			});
			if(!this.id || !this.passwd || !this.confirm_passwd || !this.name){
				this.error = '未入力の項目があります';
				return false;
			}else if(!Util.isValidCharPassword(this.id) || !Util.isValidCharPassword(this.passwd)){
				this.error = '入力値が無効です';
				return false;
			}else if(!validateLength(this.id) || !validateLength(this.passwd)) {
				this.error = 'ID, パスワードは6文字以上20文字以下で入力してください';
				return false;
			}else if(this.passwd !== this.confirm_passwd) {
				this.error = 'パスワードと確認用パスワードが一致しません';
				return false;
			}else if(!validateLengthTel(this.tel)){
				this.error = '連絡先は20文字以内で入力してください';
				return false;
			}else if(!validateLengthName(this.name)){
				this.error = '名前は40文字以内で入力してください';
				return false;
			}else{
				this.error = '';
			}
			const params = new URLSearchParams();
			params.append('id', this.id);
			params.append('passwd', this.passwd);
			params.append('name', this.name);
			params.append('tel', this.tel);
			params.append('contractor_id', this.$route.params.contractor_id);
			axios
				.post('/auth/entry', params)
				.then((response) => {
					this.$store.commit('updateDataSetID', response.data.dataset_id);
					const params = new URLSearchParams();
					params.append('id', response.data.id);
					params.append('passwd', response.data.passwd);
					params.append('contractor_id', response.data.contractor_id);
					axios
						.post('/auth', params)
						.then((response) => {
							this.$store.dispatch('setToken', {
								'access_token': TokenManager.decode(response.data.access_token.token),
								'refresh_token': TokenManager.decode(response.data.refresh_token.token),
							}).then(() => {
								let access_token = this.$store.getters.accessToken;
								if (!(access_token.pms)) {
									this.$store.dispatch('logout');
									this.$store.dispatch('addNotification', Notification.error('権限がありません', 'notificationLogin'));
								} else {
									if (access_token.pms & (PERMISSION.TYPE.ADMIN | PERMISSION.TYPE.VIEWER)) {
										this.$router.push({
											name: 'GanttBoard', 
											params: { 'contractor_id': access_token.iss },
										});
									} else if (access_token.pms & PERMISSION.TYPE.WORKER) {
										this.$router.push({
											name: 'MemberSchedule', 
											params: { 
												'contractor_id': access_token.iss, 
												'id': access_token.sub ,
											},
										});
									}else{
										this.$router.push({
											name: 'GanttBoard', 
											params: { 'contractor_id': access_token.iss },
										});
									}
									this.$store.dispatch('addNotification', Notification.info('登録に成功しました', 'notificationLogin'));
								}
							});
						})
						.catch((e) => {
							let notification = null;
							switch(e.response.status) {
								case 400: this.error = 'IDもしくはパスワードが間違っています';										break;
								case 403: this.error = 'パスワードが無効です. 再設定してください';									break;
								case 500: notification = Notification.error('情報の取得に失敗しました', 'notificationLogin');	break;
								case 504: notification = Notification.error('タイムアウトしました', 'notificationCreateData');	break;
								default : notification = Notification.error('通信に失敗しました', 'notificationLogin');		break;
							}
							if(notification)
								this.$store.dispatch('addNotification', notification);
						});
				})
				.catch((e) => {
					let notification = null;
					switch(e.response.status) {
						case 400: 
							this.error = '無効な入力値があります';
							break;
						case 409: 
							this.error = 'すでに登録されているユーザIDです';
							this.id = '';
							break;
						case 500: 
							notification = Notification.error('登録に失敗しました', 'notificationLogin');
							break;
						case 504: 
							notification = Notification.error('タイムアウトしました', 'notificationCreateData');
							break;
						default : 
							notification = Notification.error('通信に失敗しました', 'notificationLogin');
							break;
					}
					if(notification)
						this.$store.dispatch('addNotification', notification);
				});
		},
		focusPasswd: function() {
			this.$refs.signup_passwd.focus();
		},
		focusConfirmPasswd: function() {
			this.$refs.signup_confirm.focus();
		},
		focusName: function() {
			this.$refs.signup_name.focus();
		},
		focusTel: function() {
			this.$refs.signup_tel.focus();
		},
		onWindowResize: function() {
			Util.onWindowResize(() => {
				this.$store.dispatch('setWindowSize', {
					width: window.innerWidth,
					height: window.innerHeight,
				});
			});
		},
	},
	computed: {
		toLogin: function() {
			return {
				name: 'Login',
				params: { 
					'contractor_id': this.$route.params.contractor_id,
				},
			};
		},
		viewportExtraSmall: function() {
			return this.$store.getters.width < 600;
		},
		classRow: function() {
			if (!this.viewportExtraSmall)
				return ['d-flex', 'justify-center'];
			return '';
		},
		classInputGroup: function() {
			if (!this.viewportExtraSmall)
				return ['login-input-group'];
			return '';
		},
		classInputLabel: function() {
			if (!this.viewportExtraSmall)
				return ['login-input-label'];
			return '';
		},
		form: function() {
			return {
				signup_id: this.id,
				signup_passwd: this.passwd,
				signup_confirm: this.confirm_passwd,
				signup_name: this.name,
				signup_tel: this.tel,
			};
		},
	},
	created: function() {
		window.addEventListener('resize', this.onWindowResize, false);
		this.onWindowResize();
	},
	beforeDestroy: function() {
		window.removeEventListener('resize', this.onWindowResize);
	},
}
</script>
<style>
</style>
